import React from 'react';

// Small metadata pill (location, employment type, schedule, salary…).
export default function Chip({ icon: Icon, children, tone = 'default' }) {
  if (!children) return null;
  const tones = {
    default: 'border-sand bg-cream/60 text-greenDeep',
    accent: 'border-gold/40 bg-gold/15 text-[#8a6418]',
    ghost: 'border-transparent bg-transparent text-muted-foreground',
  };
  return (
    <span
      className={
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-num text-[11px] uppercase tracking-wide ' +
        (tones[tone] || tones.default)
      }
    >
      {Icon && <Icon className="h-3.5 w-3.5 shrink-0" strokeWidth={1.75} />}
      <span className="normal-case tracking-normal">{children}</span>
    </span>
  );
}
